import {
  getReportEventPropertiesFromAnalysisEntity,
  getReportEventPropertiesFromAnalysisMetaData,
} from './utils';
import { IAnalyticsAnalysisArgument, IAnalyticsEventReport } from './types';
import { IAnalysisMetadata } from '../../../../redux/slices/analyses';

// cannot use directly contextValue on execute,
// therefore create a new function to use the response of exeuction.
export const reportViewed = (
  analysis: IAnalyticsAnalysisArgument,
  isEmbedded?: boolean,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report Viewed',
    ...getReportEventPropertiesFromAnalysisEntity(analysis, isEmbedded),
  };
};

export const reportInformationIconViewed = (
  analysis: IAnalyticsAnalysisArgument,
): IAnalyticsEventReport => {
  return {
    eventName: 'Information Icon Viewed',
    ...getReportEventPropertiesFromAnalysisEntity(analysis),
  };
};

// cannot use directly contextValue on execute,
// therefore, create a new function to use the response of execution.
export const reportCreated = (
  analysis: IAnalyticsAnalysisArgument,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report Created',
    ...getReportEventPropertiesFromAnalysisEntity(analysis),
  };
};

export const reportDeleted = (
  analysisMetaData: IAnalysisMetadata,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report Deleted',
    ...getReportEventPropertiesFromAnalysisMetaData(analysisMetaData),
  };
};

export const reportScheduleCreated = (
  analysis: IAnalyticsAnalysisArgument,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report Schedule Created',
    ...getReportEventPropertiesFromAnalysisEntity(analysis),
  };
};

export const reportReplaced = (
  analysisMetaData: IAnalysisMetadata,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report Replaced',
    ...getReportEventPropertiesFromAnalysisMetaData(analysisMetaData),
  };
};

export const reportViewSql = (
  analysisMetaData: IAnalysisMetadata,
): IAnalyticsEventReport => {
  return {
    eventName: 'Report View SQL',
    ...getReportEventPropertiesFromAnalysisMetaData(analysisMetaData),
  };
};
